var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161 37.52h-2.975c-.259 0-.47-.214-.47-.48V34L161 37.52zm-1.565 2.5c0 .066-.053.12-.118.12h-5.634c-.065 0-.118-.054-.118-.12v-.54c0-.066.053-.12.118-.12h5.634c.065 0 .118.054.118.12v.54zm0 1.9c0 .066-.053.12-.118.12h-5.634c-.065 0-.118-.054-.118-.12v-.54c0-.066.053-.12.118-.12h5.634c.065 0 .118.054.118.12v.54zm0 1.9c0 .066-.053.12-.118.12h-5.634c-.065 0-.118-.054-.118-.12v-.54c0-.066.053-.12.118-.12h5.634c.065 0 .118.054.118.12v.54zm-1.41-5.94c-.453 0-.821-.376-.821-.84V34h-4.734c-.26 0-.47.215-.47.48v11.04c0 .265.21.48.47.48h8.06c.26 0 .47-.215.47-.48v-7.64h-2.975z",
    transform: "translate(-490 -321) translate(113 202) translate(224) translate(1 85)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconBlack);
export default __webpack_public_path__ + "static/media/comment_icon_black.5911a40676841112d0fefd6c22c9dd4d.svg";
export { ForwardRef as ReactComponent };